import reducer from './question-collection-reducer';

export default reducer;
export { initialState } from './question-collection-reducer';

export * from './question-collection-actions';
